import Reveal from "../components/Reveal";

export default function About() {
  return (
    <section
      id="about"
      className="bg-black pt-32 md:pt-44 pb-10 md:pb-14 px-6 overflow-hidden relative"
      style={{
        backgroundImage:
          "radial-gradient(ellipse at top, rgba(255,255,255,0.03) 0%, transparent 70%)",
      }}
    >
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <div className="text-white/40 text-sm tracking-widest uppercase">About Paisums</div>
        </Reveal>
        <Reveal delay={100}>
          <h2 className="font-instrument text-4xl md:text-6xl lg:text-7xl text-white leading-[1.1] tracking-tight mt-6">
            Pioneering <em className="italic-serif text-white/60">AI</em> for the
            <br className="hidden md:block" />{" "}
            industries that <em className="italic-serif text-white/60">move, build, and power</em> the world.
          </h2>
        </Reveal>
        <Reveal delay={220}>
          <p className="mt-10 text-white/60 text-base md:text-lg leading-relaxed max-w-3xl">
            Founded in New Zealand in 2021 by engineers with 20+ years of production experience, Paisums Technology has spent the last two years going deep on AI-driven platforms, embedding LLMs, computer vision and predictive systems into the workflows that keep mining, machinery, GIS and data-analytics organisations running.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
